import { defineComponent } from 'vue'
import { villainInfoMap } from './config'
import { SvgIcon } from '../../components/SvgIcon'
import { useStore } from './state'

export const TwoOrMore = defineComponent({
  setup () {
    const store = useStore()

    const toggleFold = () => (store.showTwoMore = !store.showTwoMore)

    return () => {
      const { showTwoMore } = store
      const folded = !showTwoMore

      return (
        <div
          class={`transition-all rounded ${
            folded ? '' : 'shadow-lg border border-gray-400 border-solid'
          }`}
        >
          <div
            class="rounded bg-gray-100 p-5 flex items-center border border-gray-400 border-solid cursor-pointer"
            onClick={toggleFold}
          >
            <div class="font-bold">주의/심각 캐릭터가 2개 이상인가요?</div>
            <SvgIcon
              name="down-indicator"
              class={`transition-all ml-auto ${folded ? '' : 'rotate-180'}`}
            />
          </div>
          <div
            class={`p-2 transition-all duration-300 overflow-hidden ${
              folded ? '!py-0 max-h-0' : 'max-h-[1000px]'
            }`}
          >
            <div>
              주의/심각 캐릭터가 여러 개 나온 경우 점수가 가장 높은 악동
              프로그램부터 시작하시거나, 아래 내용 중 현재 가장 해결하고 싶은
              문제를 찾아서 이와 관련된 캐릭터 프로그램을 먼저 들어보시는 걸
              추천 드립니다.
            </div>
            <ul class="mt-4">
              {Object.values(villainInfoMap).map(({ kor, choosingGuide }) => {
                return (
                  <li class="mt-4 first:mt-0 flex">
                    <div class="font-bold whitespace-nowrap">{kor}</div>
                    <div class="ml-2 grow">{choosingGuide}</div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      )
    }
  },
})
